import styled from 'styled-components';

export const AppWrapper = styled.div`
  * {
    margin    : 0;
    padding   : 0;
    outline   : 0;
    box-sizing: border-box;
  }

  display: grid;
  grid-template-areas:
    "header header header"
    "article article article"
    "article article article";
  grid-template-rows   : 10% 80% 10%;
  grid-template-columns: 100%;
  height               : 100vh;
  width                : 100vw;
  margin               : 0;

  #pageHeader {
    grid-area : header;
    background-color: #14181d;
    border-bottom: 1px solid hsla(0,0%,100%,.2);
  }

  #pageNav {
    grid-area : nav;
    background-color: #14181d;
  }

  .nav-item {
    cursor: pointer
  }

  .nav-item h6 {
    color: white
  }

  .nav-item:hover > h6 {
    color: orange !important
  }

  #pageArticle {
    overflow: auto;
    grid-area: article;
    background-color: #1b2026;
  }

  /* Stack the layout on small devices/viewports. */
  @media all and (max-width: 575px) {
    grid-template-areas:
      "header"
      "nav"
      "article"
    grid-template-rows   : auto;
    grid-template-columns: 20% 80%;
  }
`;